import React from "react";
import { Badge } from "antd";
import { DATETIME_FORMAT_FOR_API } from "../../../constants/constants";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import numeral from "numeral";

const DateCell = props => {
  const { onDayHover, valueDate, deadlinesToShow } = props;

  valueDate.startOf("day");

  // converto in formato utile a fare il filtro sui subjectives
  let actualDateCeil = valueDate.format(DATETIME_FORMAT_FOR_API);

  let actualCeilDeadlines = deadlinesToShow?.filter(el => {
    // Forzare el.date con orario sempre T00:00:00.000Z in modo da evitare cambiamenti di giornate nella conversione orario UTC
    let cursorDate = moment(el.date.split("T")[0] + "T00:00:00.000Z")
      .startOf("day")
      .format(DATETIME_FORMAT_FOR_API);
    return cursorDate === actualDateCeil;
  });

  const groupedDeadlines = actualCeilDeadlines.reduce((acc, val) => {
    if (val.status.confirmed === false) {
      acc.planned.push(val);
    } else {
      val.totalAmount >= 0 ?  acc.positive.push(val) : acc.negative.push(val);
    }
    return acc;
  }, {positive: [], negative: [], planned: []});

  const positiveBadge =  groupedDeadlines.positive.length > 0 &&
    <li
      key={"positiveBadge"}
      className={"eventLi"}
      onMouseEnter={ev => onDayHover(moment(valueDate))}
    >
      <Badge
        className={"badge-event ant-badge-status eventType1"}
        status="default"
        text={
          <span
            className={
              "badge-event ant-badge-status-text eventType1"
            }
          >
            <FormattedMessage id="deadlines.tocollect"/> {numeral(groupedDeadlines.positive.reduce((acc, val) => acc + val.totalAmount, 0)).format("0,0.00")} €
          </span>
        }
      />
    </li>;

  const negativeBadge =  groupedDeadlines.negative.length > 0 &&
    <li
      key={"negativeBadge"}
      className={"eventLi"}
      onMouseEnter={ev => onDayHover(moment(valueDate))}
    >
      <Badge
        className={"badge-event ant-badge-status eventTypeDefault"}
        status="default"
        text={
          <span
            className={
              "badge-event ant-badge-status-text eventTypeDefault"
            }
          >
            <FormattedMessage id="deadlines.due"/> {numeral(Math.abs(groupedDeadlines.negative.reduce((acc, val) => acc + val.totalAmount, 0))).format("0,0.00")} €
          </span>
        }
      />
    </li>;

  const plannedBadge =  groupedDeadlines.planned.length > 0 &&
  <li
    key={"plannedBadge"}
    className={"eventLi"}
    onMouseEnter={ev => onDayHover(moment(valueDate))}
  >
    <Badge
      className={"badge-event ant-badge-status eventType2"}
      status="default"
      text={
        <span
          className={
            "badge-event ant-badge-status-text eventType2"
          }
        >
          {groupedDeadlines.planned.length === 1 ? groupedDeadlines.planned[0].description.title : <FormattedMessage id="deadlines.table.otherPlanned" values={{total: groupedDeadlines.planned.length}}/> }
        </span>
      }
    />
  </li>;  

  return (
    <div className="ant-fullcalendar-date">
      <div className="ant-fullcalendar-content">
        <ul className="events">{[positiveBadge, negativeBadge, plannedBadge]}</ul>
      </div>
      <div
        className={[
          "ant-fullcalendar-value",
          [6, 0].indexOf(valueDate.day()) > -1 && "weekend"
        ].join(" ")}
      >
        {valueDate.date()}
      </div>
    </div>
  );
};

export default DateCell;
